var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7502 14.75L11.4929 11.4928M11.4929 11.4928C12.0501 10.9356 12.492 10.2742 12.7936 9.54619C13.0951 8.81822 13.2503 8.03798 13.2503 7.25003C13.2503 6.46208 13.0951 5.68184 12.7936 4.95387C12.492 4.2259 12.0501 3.56445 11.4929 3.00728C10.9357 2.45012 10.2743 2.00815 9.54631 1.70661C8.81834 1.40508 8.03811 1.24988 7.25015 1.24988C6.4622 1.24988 5.68197 1.40508 4.95399 1.70661C4.22602 2.00815 3.56457 2.45012 3.0074 3.00728C1.88216 4.13253 1.25 5.65869 1.25 7.25003C1.25 8.84137 1.88216 10.3675 3.0074 11.4928C4.13265 12.618 5.65881 13.2502 7.25015 13.2502C8.84149 13.2502 10.3677 12.618 11.4929 11.4928Z",
    stroke: "#9A9A9A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6a6d31efcfbc62cf9ba4bab0f349dc57.svg";
export { ForwardRef as ReactComponent };